const { htmlDecode } = require('@/functions/html');

/**
 * @param {UserService} userService
 * @constructor
 */
const CurrencyService = function (
    userService
) {
    this.userService = userService;
};

CurrencyService.prototype = {
    /**
     * @return {string}
     */
    getSymbol: function getSymbol() {
        // Try and use the company's currency
        const currency = this.userService.getCompany()?.currency;
        if (currency && currency.html) {
            // Decode html entity
            return htmlDecode(currency.html);
        }

        return '';
    },
};

module.exports = CurrencyService;
